import { useGetSiteApi } from "../../../../api";
import { Module } from "../../../../constants/modules";
import { classes } from "../../../../helper";
import { useSelectedSites } from "../../../../hooks";
import { withGlobalParams } from "../../../../site-selection/withGlobalParams";
import Tooltip from "../../../Tooltip";
import styles from "./ServiceLink.module.css";

type Props = {
  module: Module;
};

function ServiceLink({ module }: Props) {
  const { getHref, enabled, supportsMultiSite } = module;

  const { selectedSite, selectedSites, isMultiSiteMode } = useSelectedSites();
  const { data } = useGetSiteApi(selectedSite);

  const unavailableForMultiSite = isMultiSiteMode && !supportsMultiSite;

  if (unavailableForMultiSite) {
    return (
      <Tooltip
        content="This feature is not available for multiple sites."
        placement="bottom"
        anchorToCursor
      >
        <ServiceLinkContent module={module} disabled />
      </Tooltip>
    );
  }

  const href =
    enabled && data && selectedSite
      ? getHref(
          selectedSite,
          data.rootEquipments?.length > 0 ? data.rootEquipments[0] : "",
          data.systemOverviewReport,
          data.projectOverviewReport,
          data.productionArea
        )
      : undefined;

  return href ? (
    <a href={supportsMultiSite ? withGlobalParams(href, selectedSites) : href}>
      <ServiceLinkContent module={module} />
    </a>
  ) : (
    <div title="Contact your ABB representative to access this service">
      <ServiceLinkContent module={module} />
    </div>
  );
}

function ServiceLinkContent({
  module,
  disabled = false,
}: {
  module: Module;
  disabled?: boolean;
}) {
  const { title: text, icon, enabled, isHighlighted } = module;

  const isDisabled = disabled || !enabled;

  return (
    <div
      className={classes(
        styles["service-link"],
        isHighlighted ? styles.highlighted : "",
        isDisabled ? styles.disabled : styles.enabled
      )}
    >
      {icon}
      <p>{text}</p>
    </div>
  );
}

export default ServiceLink;
